import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const traceableAi = defineConnector({
  identifier: "traceableAi",
  name: "Traceable AI",
  tagLine: "API security and observability",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) =>
    domain ? exactUrlToRegex(domain) : "https://[^/]*\\.traceable\\.ai/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Traceable platform, go to **Your Account → My Preferences → API Tokens** and click **Generate API Token**.",
        },
      ],
    },
    {
      title: "Enter your Traceable AI details",
      items: [
        {
          kind: "hostname",
          label: "API hostname",
          defaultValue: "api.traceable.ai",
          placeholder: "api.us1.traceable.ai",
          helperText:
            "Your region’s API hostname, without https:// or /graphql. Defaults to api.traceable.ai.",
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain || "api.traceable.ai"}/graphql`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ __typename }" }),
      expectedBodyContains: '"__typename"',
    }),
  },
  publicEnvVars: ({ domain }) => ({
    TRACEABLE_AI_URL: `https://${domain || "api.traceable.ai"}`,
  }),
});
